import React from 'react';
import { format } from 'date-fns';

export default function (props) {
  if (!props.date) {
    return null;
  }

  const date = new Date(props.date);
  const formatStr = props.format || 'Pp';
  const formatted = format(date, formatStr);
  
  return <span>{formatted}</span>;
}